<div id="alert" class="flex justify-between items-center" (click)="goToURL()">
  <span class="alert-text" [ngClass]="classes">
    @if (isMessage()) {
      <mat-icon class="mr-2">notifications_active</mat-icon>
    }
    @if (isSuccess()) {
      <mat-icon class="mr-2">notifications_active</mat-icon>
    }
    @if (isError()) {
      <mat-icon class="mr-2">error</mat-icon>
    }
    <span>{{ message }}</span>
  </span>


  <!-- <button mat-button>
  <mat-icon class="mr-2 goto">near_me</mat-icon>
</button> -->
<button mat-button click-stop-propagation (click)="dismiss($event)">
  <mat-icon class="mr-2 dismiss">cancel</mat-icon>
</button>
</div>